


















































import { BUTTON } from '@/constants/label';
import Vue from 'vue';
import { getMessageInfo } from '@/utils/message';

export default Vue.extend({
  name: 'CtrlMessageDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    messageID: {
      type: String,
      default: '',
    },
    messageTextParam: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  data: () => ({
    BUTTON: BUTTON,
    messageType: '',
    messageText: '',
    defaultFocus: '',
  }),
  watch: {
    messageTextParam: {
      handler(newValue) {
        if (newValue) {
          this.getMessage();
        }
      },
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refs(): any {
      return this.$refs;
    },
    handleCancel(): void {
      // Cancel 押下時に呼び出す call back function (emit で処理するような作りでも可)
      if (this.messageType !== 'question') return;
      this.$emit('update:value', false);
      this.$emit('cancel');
    },
    handleOk(): void {
      // OK 押下時に呼び出す call back function (emit で処理するような作りでも可)
      this.$emit('update:value', false);
      this.$emit('ok');
    },
    getMessage(): void {
      // MessageId一覧から メッセージ情報を取得
      const info =
        this.messageTextParam.length > 0
          ? getMessageInfo(this.messageID, this.messageTextParam)
          : getMessageInfo(this.messageID);
      this.messageType = info.messageType ? info.messageType : '';
      this.messageText = info.messageText ? info.messageText : '';
      this.defaultFocus = info.defaultFocus ? info.defaultFocus : '';
    },
    focusInput(inputRef: string): void {
      const refs = this.refs();
      refs[inputRef].$el.focus();
    },
  },
  created() {
    // 起動時に props.messageID に該当する data を MessageId一覧 から取得して、this.message に代入している
    this.getMessage();
  },
  mounted() {
    const refName = `btn${
      this.defaultFocus ? this.defaultFocus : 'Button2'
    }Ref`;
    this.focusInput(refName);
  },
});
